import React, { useEffect, useState, useContext } from 'react';
import '../../../App.css';
import { differenceInWeeks, parseISO, format } from 'date-fns';
import ImageGallery from './ImageGallery';
import DropDownStructure from '../../DropDownStructure';
import PersonalInfo from './PersonalInfo';


const DropDownSection = ({ model, assets, setModel = {}, isEditMode = false, setUploadImages }) => {
    const [downloadLinks, setDownloadLinks] = useState({});

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A'; // Return 'N/A' if dateString is null or undefined
        try {
            const date = parseISO(dateString);
            return format(date, 'dd/MM/yyyy');
        } catch (error) {
            console.error('Error parsing date:', error);
            return 'Invalid Date';
        }
    };

    const ColorExplanationBoxes = () => (
        <div className='colorBoxes'>
            <span style={{ backgroundColor: '#E2F0FC', border: '1px solid #A8A8A8', padding: '10px' }}>
            </span>
            <span>  &lt;3 Weeks</span>
            <span style={{ backgroundColor: '#E4A54D', border: '1px solid #A8A8A8', padding: '10px' }}>
            </span>
            <span>&lt; 6 Weeks</span>
            <span style={{ backgroundColor: '#E73323', border: '1px solid #A8A8A8', padding: '10px' }}>
            </span>
            <span>&gt; 9 Weeks</span>
        </div>
    );

    const getBorderColorFromTimestamp = (timestamp) => {
        if (!timestamp) return '3px solid gray'; // Default color if timestamp is undefined
        const date = new Date(timestamp);
        try {
            const weeksDiff = differenceInWeeks(new Date(), date);

            if (weeksDiff < 3) return '3px solid #E2F0FC';  // < 3 weeks
            if (weeksDiff < 6) return '3px solid #E4A54D'; // < 6 weeks
            if (weeksDiff > 9) return '3px solid #E73323';    // < 9 weeks
            return '3px solid gray';                      // > 9 weeks
        } catch (error) {
            console.error('Error parsing date:', error);
            return '3px solid gray'; // Default color if parsing fails
        }
    };

    return (
        <div>
            <DropDownStructure
                summary={<h2>{model.firstName || ''} {model.lastName || ''}</h2>}
                details={
                    <PersonalInfo model={model} setModel={setModel} isEditMode={isEditMode} />
                }
                expand={true}
            />


            <DropDownStructure
                summary={<h2>Polaroids</h2>}
                details={
                    <div>
                     {assets.primaryImages.length > 0 ?
                        <div>
                        <ColorExplanationBoxes />
                        <ImageGallery isEditMode={isEditMode}
                            initialImages={assets.primaryImages}
                            /* this is not working!, just so it looks like the polaroids have a border based on the date */
                            styleFunction={getBorderColorFromTimestamp}
                            model={model} setModel={setModel}
                            setUploadImages={setUploadImages}
                        />
                        </div>
                        : <p>No Polaroids available</p>
                     }
                    </div>
                }
            />

            <DropDownStructure
                summary={<h2>Pictures</h2>}
                details={
                    <div>
                        {assets.secondaryImages.length > 0 ?
                            <div>
                                <ImageGallery isEditMode={isEditMode}
                                    initialImages={assets.secondaryImages}
                                    model={model} setModel={setModel}
                                />
                            </div>
                            : <p>No Pictures available</p>
                        }
                    </div>
                }
            />

            <DropDownStructure
                summary={<h2>Fitting</h2>}
                details={
                    <div>
                        {assets.fittingImages?.length > 0 ? assets.fittingImages.map((section, index) => (
                            <div key={index}>
                                <h3>{section.client} - {section.category} - {formatDate(section.date)}</h3>
                                <ImageGallery isEditMode={isEditMode}
                                    initialImages={section.images}
                                    model={model} setModel={setModel}
                                />
                            </div>
                        )) : <p>No Fitting available</p>}
                    </div>
                }
            />

            <DropDownStructure
                summary={<h2>Files</h2>}
                details={
                    <div>
                        {console.log('modelFiles', model.files)}
                        {assets.files && model.files?.length > 0 ? assets.files.map((file, index) => (
                            file != null ? (
                            <div key={index}>
                                <a href={downloadLinks[file.path]} download={file.name}>{file.name}</a>
                            </div>) : (<div key={index}></div>)
                        )) : <p>No Files available</p>}
                    </div>
                }
            />


            <DropDownStructure
                summary={<h2>History</h2>}
                details={
                    <div className='history'>
                        <h3>Agency History:</h3>
                        {model.historyDetails && model.historyDetails.bookingAgencyHistory && model.historyDetails.bookingAgencyHistory.length > 0 ? (
                            <ul>
                                {model.historyDetails.bookingAgencyHistory.map((agency) => (
                                    <li key={agency.id}>
                                        <strong>{agency.name}</strong> (ID: {agency.id})
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No booking agency history available.</p>
                        )}

                        <h3>Booker History:</h3>
                        {model.historyDetails && model.historyDetails.bookerHistory && model.historyDetails.bookerHistory.length > 0 ? (
                            <ul>
                                {model.historyDetails.bookerHistory.map((booker) => (
                                    <li key={booker.ref}>
                                        <strong>{booker.name}</strong> (Ref: {booker.ref})
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No booker history available.</p>
                        )}
                    </div>
                }
            />
            <hr />
        </div>
    );
};

export default DropDownSection;
